/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Heating_Curve_History_Starting_TempInputs */



/**
* | output |
* | --- |
* | "Starting temperature (°C)" |
*
* @param {Heating_Curve_History_Starting_TempInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const heating_curve_history_starting_temp = /** @type {((inputs?: Heating_Curve_History_Starting_TempInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Heating_Curve_History_Starting_TempInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Starting temperature (°C)")
	return /** @type {LocalizedString} */ ("Température de départ (°C)")
});